import { InjectionToken } from '@angular/core';
import { ChatDirectoryPort } from './chat-directory.port';

export const CHAT_DIRECTORY_PORT = new InjectionToken<ChatDirectoryPort>('CHAT_DIRECTORY_PORT');
